/**
 * Textos de la capa HTTP del motor, la única parte de la feature que va en el bundle inicial de Sirius (el
 * interceptor compuesto `agents-engine.interceptor.ts` → `error.interceptor`, `ApiNotificationsService` y sus
 * plantillas). Viven aparte para que el bundle inicial no arrastre el diccionario entero de la feature
 * (`COMMON_MESSAGES`, lazy): webpack no parte un módulo entre chunks, así que todo lo que el código lazy leyera de
 * `COMMON_MESSAGES` acabaría en `main.js`. `COMMON_MESSAGES.errors` y `COMMON_MESSAGES.actions.close` son estos
 * mismos objetos.
 */
export const HTTP_MESSAGES = {
  close: 'Cerrar',
  errors: {
    title: 'No se pudo completar la acción',
    network: 'No se pudo contactar con la API en {origin}',
    timeout: 'La API no respondió a tiempo',
    unauthorizedTitle: 'Tu sesión de Sirius dejó de ser válida',
    unauthorized: 'La sesión de Sirius no es válida o caducó: vuelve a iniciar sesión.',
    forbiddenTitle: 'Tu usuario no tiene el acceso necesario',
    forbidden: 'Tu usuario no tiene el acceso `{scope}`',
    forbiddenGeneric: 'Tu usuario no tiene permiso para esta operación',
    notFound: 'El recurso no existe',
    conflict: 'El estado cambió antes de aplicar la acción',
    validation: 'Revisa los campos marcados',
    rateLimited: 'Límite de runs por minuto de tu organización; reintenta en unos segundos',
    server: 'La API respondió con un error ({status})',
    unknown: 'Error inesperado',
    requestId: 'Id de petición: {requestId}',
    loadFailed: 'No se pudo cargar',
    scopeTooltip: 'Necesita el acceso {access}',
  },
} as const;
